import { useEffect, useRef } from "react";

import { RichText } from "@atlassiansox/bxp-content-framework";

import {
    Column,
    Row,
    Container,
    useFooterContext,
    AnalyticsAttributesProvider,
    LanguageSelectForm,
    LogoAtlassian
} from "../../components";
import { UiFooterNavBasicModel } from "../../models";
import { renderViewModels } from "../../render-view-model";

import { Footer, Links } from "./UiFooterNavBasic.styles";

export type UiFooterNavProps = {
    readonly model: UiFooterNavBasicModel;
};

const UiFooterNavBasic = ({ model }: UiFooterNavProps) => {
    const {
        type,
        content: {
            entryTitle,
            links,
            selectLanguageLabel,
            tagline,
            isFullWidth
        }
    } = model;
    const { setFooterHeight } = useFooterContext();
    const footerRef = useRef<HTMLDivElement>(null);
    const columnStyles = isFullWidth ? undefined : { offset: "2", span: "8" };

    useEffect(() => {
        function handleResize() {
            if (footerRef.current) {
                const height = footerRef.current.offsetHeight;
                setFooterHeight(height);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [footerRef, setFooterHeight]);

    return (
        <AnalyticsAttributesProvider
            value={{
                eventContainer: "globalFooter",
                eventComponent: type,
                parentLabel: entryTitle
            }}
        >
            <Footer ref={footerRef}>
                <Container>
                    <Row>
                        <Column md={columnStyles}>
                            <LanguageSelectForm
                                iconColor="N100"
                                selectLanguageLabel={selectLanguageLabel}
                                showGlobeIcon={false}
                            />
                            <hr role="presentation" />
                            <LogoAtlassian />
                            {!!links?.length && (
                                <Links>{renderViewModels(links)}</Links>
                            )}
                            {tagline && (
                                <RichText
                                    document={tagline}
                                    className="tagline"
                                />
                            )}
                        </Column>
                    </Row>
                </Container>
            </Footer>
        </AnalyticsAttributesProvider>
    );
};

export default UiFooterNavBasic;
